var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.52,143.52q1.89-4.86,4.15-9.54c20.44-42.2,69.46-60.06,114-52.49,49.92,8.5,85.35,44.18,95.88,93.12,8.34,38.75,32.08,42.74,43.12,25.49s38.42-33.6,65.1-15c41.64,29,17,89.38-9.47,119.71-44.15,50.54-110.36,75.63-176.29,61-54.79-12.17-107.2-47.85-131.55-99.38C67.06,229.62,64.48,182.28,79.52,143.52Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,143.52q1.89-4.86,4.15-9.54c20.44-42.2,69.46-60.06,114-52.49,49.92,8.5,85.35,44.18,95.88,93.12,8.34,38.75,32.08,42.74,43.12,25.49s38.42-33.6,65.1-15c41.64,29,17,89.38-9.47,119.71-44.15,50.54-110.36,75.63-176.29,61-54.79-12.17-107.2-47.85-131.55-99.38C67.06,229.62,64.48,182.28,79.52,143.52Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-37"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-37",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "391.75 390.78 381.03 391.35 385.05 409.26 393.39 408.91 391.75 390.78",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.75 390.78 381.03 391.35 383.36 401.7 392.71 401.27 391.75 390.78",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.17 410.12 324.27 409.8 328.42 391.02 316.85 391.47 316.17 410.12",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.85 391.48 328.42 391.04 325.91 402.36 316.43 402.72 316.85 391.48",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.55,408.67H384.7a.72.72,0,0,0-.69.56l-1.6,7.22a1.2,1.2,0,0,0,.92,1.42,1.23,1.23,0,0,0,.27,0c3.18-.05,5.5-.24,9.51-.24,2.46,0,9.9.25,13.3.25s3.85-3.36,2.46-3.67c-6.25-1.36-11-3.25-13-5A2,2,0,0,0,394.55,408.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.11,409.8a.2.2,0,0,1-.15-.17.18.18,0,0,1,.09-.18c.29-.19,2.91-1.8,3.81-1.33a.55.55,0,0,1,.33.53,1.13,1.13,0,0,1-.4,1,2.48,2.48,0,0,1-1.56.42A10,10,0,0,1,395.11,409.8Zm.55-.27a3.91,3.91,0,0,0,2.89-.15.78.78,0,0,0,.26-.69c0-.15-.07-.22-.12-.22a.57.57,0,0,0-.25-.06A8,8,0,0,0,395.66,409.53Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.05,409.84a.24.24,0,0,1-.09-.18c0-.11.21-2.44,1.15-3.21a1,1,0,0,1,.81-.24.63.63,0,0,1,.62.5c.17.86-1.45,2.64-2.29,3.1h-.09A.2.2,0,0,1,395.05,409.84Zm1.3-3.16a4.53,4.53,0,0,0-1,2.54c.83-.63,1.86-2,1.76-2.51,0,0,0-.19-.28-.19h-.09A.7.7,0,0,0,396.35,406.68Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.32,408.41h-9.85a.73.73,0,0,0-.69.56l-1.6,7.22a1.21,1.21,0,0,0,.93,1.42,1.09,1.09,0,0,0,.26,0c3.19-.06,5.51-.25,9.51-.25,2.46,0,9.9.26,13.3.26s3.85-3.37,2.46-3.68c-6.25-1.36-11-3.24-13-5A2,2,0,0,0,326.32,408.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.88,409.54a.18.18,0,0,1-.14-.17.16.16,0,0,1,.09-.18c.29-.19,2.91-1.8,3.8-1.33a.57.57,0,0,1,.33.53,1.13,1.13,0,0,1-.4,1,2.45,2.45,0,0,1-1.56.41A9.51,9.51,0,0,1,326.88,409.54Zm.56-.27a3.93,3.93,0,0,0,2.88-.14.8.8,0,0,0,.26-.69c0-.16-.07-.23-.12-.23a.43.43,0,0,0-.25,0A7.87,7.87,0,0,0,327.44,409.27Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.83,409.58a.18.18,0,0,1-.09-.18c0-.11.2-2.44,1.14-3.2a1,1,0,0,1,.81-.25.62.62,0,0,1,.62.5c.17.86-1.45,2.65-2.29,3.1h-.09A.19.19,0,0,1,326.83,409.58Zm1.3-3.16a4.54,4.54,0,0,0-1,2.54c.83-.63,1.87-2,1.76-2.51,0-.05,0-.19-.28-.19h-.09A.67.67,0,0,0,328.13,406.42Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.74,384.79a4.79,4.79,0,0,1-4.12,4.83l-6.83,1a4.78,4.78,0,0,1-5.38-3.93C375.24,374,368.67,337.2,360,304.51c-4.43-16.69-9.4-32.3-14.61-43.11a1019.48,1019.48,0,0,1-13.94,127.43,4.78,4.78,0,0,1-4.71,3.95h-6.89a4.77,4.77,0,0,1-4.78-4.87c.43-21,1.83-104.74-2-152.4l44.68-25.71S390.63,253,393.74,384.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.47 390.32 381.13 393.75 392.6 391.97 392.17 388.41 380.47 390.32",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.56,240.85s2.23-8.54,1.44-14.08c0,0-3.67,10.76-6,8.23-3.09-3.34,6-8.23,6-8.23s5.65-3.42,7.82-1.35c5.26,5-7.82,1.35-7.82,1.35s3.57,7.75,6.47,10.65",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.17,392.28a.25.25,0,0,1-.12,0c-3.89-1-3.65-5.62-3-19.26.39-7.76.93-18.4,1-33,.26-81.14-3.37-107.13-3.41-107.38a.5.5,0,0,1,1-.15c0,.26,3.68,26.29,3.42,107.54-.05,14.66-.59,25.31-1,33.08-.66,13-.88,17.43,2.21,18.25a.5.5,0,0,1,.36.61A.5.5,0,0,1,319.17,392.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,304.51c-4.43-16.69-9.4-32.3-14.61-43.11a19.92,19.92,0,0,0,8-11.63S362.38,282.64,360,304.51Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.95 390.39 315.95 394.61 328.42 395.65 329.32 392.01 315.95 390.39",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.17,129.55l-12.61,4.35s-1.31-2.18-8.23,4.55-7.32,8.75-3.56,9.72,6.13,1.83,8.11,1.2,8.06-7.16,7.79-7.76a4.78,4.78,0,0,1,0-2l11.19-3.9Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.14,176.94,320.92,174l-11.38-5.34c1.7-17,.41-24.06-6-26.33a53.9,53.9,0,0,0-15.69-2.88L284.49,131s17-4.63,28.54,0c8.74,3.49,13.62,17.16,14.83,29.88h0A52.23,52.23,0,0,1,327.14,176.94Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.14,176.94,320.92,174c3.23-3.72,5.54-9.16,6.94-13.17A52.23,52.23,0,0,1,327.14,176.94Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,209.8s-16.28,12.13-44.43,29.59c0,0-3.63-6.56-8.6-14.75-3.72-6.13-8.19-13.17-12.44-19a73.07,73.07,0,0,0-8.1-9.75s22.39-12.19,25.4-27.17C309.54,168.68,331.38,170.47,357.71,209.8Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.53,183.94c-2.44,3.43-8.64,8.22-14.66,8.29a8.58,8.58,0,0,0-1-5.5c-2.3-4.55-7.59-8.89-11.21-11.38l16.57-4.44c.26.57.85,2.9,1.29,4.07a3.32,3.32,0,0,0,.25.59,8.55,8.55,0,0,0,2.81,3c2,1.17,4-.08,6.95-2.56C311.88,176.54,309.69,182.3,308.53,183.94Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.49,175a13,13,0,0,1-6.65,11.75c-2.3-4.55-7.59-8.89-11.21-11.38l16.57-4.44C298.46,171.48,299.05,173.81,299.49,175Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.88,156.89a6.47,6.47,0,0,0-4.3,8.12c1,3.1,2.75,6.45,5.92,7.92,6.64,3.08,2.66-17.33,2.66-17.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.88,156.89a6.47,6.47,0,0,0-4.3,8.12c1,3.1,2.75,6.45,5.92,7.92,6.64,3.08,2.66-17.33,2.66-17.33Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.1,178.35a10.15,10.15,0,0,1-10.68,6.09,11.43,11.43,0,0,1-8.06-4.87c-4.17-6.15-7.37-17.69-1.14-23.47,4.41-4.15,12.92-5.86,17.07-1.43,1.19,1.25.5,4.69,1,6.35C298.68,168.69,300.45,173.08,298.1,178.35Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.68,167.43c.27.59.1,1.23-.31,1.38s-.91-.23-1.14-.83-.09-1.23.3-1.38S285.44,166.82,285.68,167.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.76,170.05a1,1,0,0,1-.3,1.38c-.4.15-.91-.23-1.15-.84s-.09-1.23.31-1.38S278.54,169.47,278.76,170.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.08,169.52a23.51,23.51,0,0,1-.95,6.34,3.79,3.79,0,0,0,3.15-.57Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.08,168.06a.41.41,0,0,0,.38-.14,3.07,3.07,0,0,1,2.46-1.28.39.39,0,0,0,.41-.35.38.38,0,0,0-.35-.41h0a3.79,3.79,0,0,0-3.12,1.57.37.37,0,0,0,.06.53h0A.61.61,0,0,0,275.08,168.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,164.15a.35.35,0,0,0,.17-.15.38.38,0,0,0-.22-.49h0a3.78,3.78,0,0,0-3.48.39.38.38,0,0,0-.08.53h0a.4.4,0,0,0,.54.08h0a3.12,3.12,0,0,1,2.77-.27A.39.39,0,0,0,286,164.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.43,152.72c-2.46-.21-3.81,3.08-2.8,5.34a5.2,5.2,0,0,1,.57,1.92c-.17,3.19,2.87,7.06,5.61,8.11,0,0-.33-1.25.8-1.3s2.91,6.44,1.88,10.14c0,0,2.16-3.75,1.71-11a31.56,31.56,0,0,0-1.3-8.51C298.06,154.86,294.42,152.89,292.43,152.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.43,152.72c-2.46-.21-3.81,3.08-2.8,5.34a5.2,5.2,0,0,1,.57,1.92c-.17,3.19,2.87,7.06,5.61,8.11,0,0-.33-1.25.8-1.3s2.91,6.44,1.88,10.14c0,0,2.16-3.75,1.71-11a31.56,31.56,0,0,0-1.3-8.51C298.06,154.86,294.42,152.89,292.43,152.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9,165.94a7.63,7.63,0,0,1-2.73,5.16c-2.08,1.7-4.19.1-4.51-2.42-.27-2.24.44-5.89,3-6.59S302.1,163.46,301.9,165.94Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.12,165.21s.25,3.73-1.79,6.25-5.13.95-8.7,4.88a5.87,5.87,0,0,0-3,.85c-1.25.87-3-2.12-3.64-4.52,0,0-.43,16.25,11.64,13.1s12.28-9,7-18.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.12,165.21s.25,3.73-1.79,6.25-5.13.95-8.7,4.88a5.87,5.87,0,0,0-3,.85c-1.25.87-3-2.12-3.64-4.52,0,0-.43,16.25,11.64,13.1s12.28-9,7-18.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.17,174.82a6.06,6.06,0,0,1-2.35,3.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.11,168.85a2.54,2.54,0,0,0,2.88,1",
    style: {
      fill: "none",
      stroke: "#de5753",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.4,170.9s-.46,1.93-1.92,1.85",
    style: {
      fill: "none",
      stroke: "#de5753",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,163s3-3.43,8.94-2.51",
    style: {
      fill: "none",
      stroke: "#de5753",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.55,160.32a10,10,0,0,1,7.7-2.15",
    style: {
      fill: "none",
      stroke: "#de5753",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.68,224.64c-3.72-6.13-8.19-13.17-12.44-19l1.07-1.56S306.24,208.38,304.68,224.64Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.91,240.85l8.44,2.38s.43-.79,3.17-1.19,1.55,4.42,1.74,9.73-1,7.36-3.36,6.83-3.27-8-3.27-8l-9.42-1.36Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.14,195.84c-7.32,7-18.63,28.51-11,40.64s30.63,14.14,30.63,14.14l2.89-9.86s-18-5.93-19.67-10.82,9.11-18.81,9.11-18.81,2.41-6.21-.39-11.61S284.14,195.84,284.14,195.84Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.74,191.83l2.92-1.87-.26-2.16a.22.22,0,0,1,.12-.24.24.24,0,0,1,.27,0l3.49,2.51L323.4,187a.25.25,0,0,1,.41-.26l1.69,1.56v-1.6a.22.22,0,0,1,.1-.2l2.6-2a4.11,4.11,0,0,0-2.54-2.46c-2.67-1-4.32,1.53-4.31,3.92-2.32-.56-5.12.48-4.79,3.3A4.12,4.12,0,0,0,317.74,191.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,186.85v2.05a.25.25,0,0,1-.15.23.25.25,0,0,1-.27,0l-1.45-1.33.83,2.89a.24.24,0,0,1-.1.27.26.26,0,0,1-.29,0l-3.61-2.6.21,1.74a.25.25,0,0,1-.11.24l-2.94,1.88c2.21,1.76,6.18,1.56,8.25,1.3l.81-.1.28-.76c.66-1.77,1.61-5,.91-7.54Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.56,152.79,143.9,152s-2.84-2-11.77.78c-.8.25-.21,2.77,1.87,6.79.17.35,2.62.22,5.06-.06,4.67-.54,4.81-1.05,4.84-2h7.21Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.53 408.09 161.21 406.73 162.06 397.72 162.85 389.45 170.61 389.84 168.98 399.5 167.53 408.09",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72,407c0-.71,8.76-.16,8.76-.16s5.38,5.48,10.61,6.71,2.31,4.36-3.54,4.36H161.1C157,417.9,159.55,414.37,159.72,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.94 399.69 162.03 397.89 162.84 389.54 170.6 389.88 168.94 399.69",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.56 407.4 220.1 407.4 219.04 398.41 218.08 390.16 225.75 388.91 226.18 398.7 226.56 407.4",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.72,407c0-.71,8.76-.16,8.76-.16s5.38,5.48,10.61,6.71,2.31,4.36-3.54,4.36H220.1C216,417.9,218.55,414.37,218.72,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.18 398.9 219.04 398.59 218.08 390.25 225.75 388.96 226.18 398.9",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.08,409.07a10.93,10.93,0,0,1-3.62-1.11.16.16,0,0,1-.08-.06h0l0,0a.28.28,0,0,1,0-.18c0-.09.77-2.13,1.95-2.62a1.34,1.34,0,0,1,1.14,0c.39.19.59.43.57.73,0,.46-.65.93-1.36,1.3a3.55,3.55,0,0,1,2,.22.94.94,0,0,1,.47.59.84.84,0,0,1-.21.93A1.24,1.24,0,0,1,173.08,409.07Zm-2.82-1.25c1.29.54,2.89,1,3.3.69,0,0,.15-.12.06-.47a.48.48,0,0,0-.25-.3C172.74,407.38,171.24,407.6,170.26,407.82Zm1.56-2.41a.91.91,0,0,0-.35.07,3.83,3.83,0,0,0-1.5,1.88c1.3-.49,2.55-1.17,2.57-1.56,0-.12-.19-.24-.31-.29A.88.88,0,0,0,171.82,405.41Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.08,409.07a10.93,10.93,0,0,1-3.62-1.11.16.16,0,0,1-.08-.06h0l0,0a.28.28,0,0,1,0-.18c0-.09.77-2.13,1.95-2.62a1.34,1.34,0,0,1,1.14,0c.39.19.59.43.57.73,0,.46-.65.93-1.36,1.3a3.55,3.55,0,0,1,2,.22.94.94,0,0,1,.47.59.84.84,0,0,1-.21.93A1.24,1.24,0,0,1,232.08,409.07Zm-2.82-1.25c1.29.54,2.89,1,3.3.69,0,0,.15-.12.06-.47a.48.48,0,0,0-.25-.3C231.74,407.38,230.24,407.6,229.26,407.82Zm1.56-2.41a.91.91,0,0,0-.35.07,3.83,3.83,0,0,0-1.5,1.88c1.3-.49,2.55-1.17,2.57-1.56,0-.12-.19-.24-.31-.29A.88.88,0,0,0,230.82,405.41Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.49,226.34S228.33,256.83,228.33,391l-10.57,2s-14.5-71.25-26.31-96.31c0,0-7.75,55.49-19.2,97l-11-2s2.2-64.74,1.55-96.41c-.77-37.79-.53-52.61-.53-52.61Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.33,391l-10.57,2s-6.4-31.47-14.17-59.93c-3.91-14.37-8.18-28-12.14-36.38,0,0-7.75,55.49-19.2,97L163,392.07l-1-.18-.78-.14s2.2-64.74,1.55-96.41c-.77-37.79-.53-52.61-.53-52.61l1.29-.8,1-.65,27.93-14.94S228.33,256.83,228.33,391Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.59,333.09c-3.91-14.37-8.18-28-12.14-36.38,0,0,1.39-12.66,1.79-25.84C193.24,270.87,209.61,300.27,203.59,333.09Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.81,247.51s1.84-7.07,1.19-11.64c0,0-3,8.89-5,6.8-2.55-2.77,5-6.8,5-6.8s4.67-2.83,6.46-1.12c4.35,4.16-6.46,1.12-6.46,1.12s2.95,6.4,5.35,8.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.41,285.9c.15,17.21.14,69.23-1.43,106.17l-1-.18c1.56-36.87,1.57-88.79,1.42-106-.18-20.93-.36-36.81.11-44l1-.65C164.11,248,164.22,264.27,164.41,285.9Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.15,185.33a102.89,102.89,0,0,1-2.81,12.12l-3.85-2.89-8.16-6.13s4.91-17.24,2.8-21.93-17.53-8.76-17.53-8.76l.23-6.17S167,150.22,175.51,160C180.28,165.49,179.64,176.62,178.15,185.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.15,185.33a102.89,102.89,0,0,1-2.81,12.12l-3.85-2.89-8.16-6.13s4.91-17.24,2.8-21.93-17.53-8.76-17.53-8.76l.23-6.17S167,150.22,175.51,160C180.28,165.49,179.64,176.62,178.15,185.33Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.15,185.33a102.89,102.89,0,0,1-2.81,12.12l-3.85-2.89A37.24,37.24,0,0,0,178.15,185.33Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.49,226.34s-16,13.67-30.26,16.39a39.33,39.33,0,0,0-7.15-8.15,64.72,64.72,0,0,0-7.49-5.8c-.64-.41-1.35-.93-2.11-1.53-3.72-2.94-8.31-8-8.3-13.23,0-.5,19.31-11.08,26.15-25.59C163.33,188.43,194.45,200.63,192.49,226.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.49,226.34s-16,13.67-30.26,16.39a39.33,39.33,0,0,0-7.15-8.15,64.72,64.72,0,0,0-7.49-5.8c-.64-.41-1.35-.93-2.11-1.53-3.72-2.94-8.31-8-8.3-13.23,0-.5,19.31-11.08,26.15-25.59C163.33,188.43,194.45,200.63,192.49,226.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.22,200.12s2.93-4,5.6-5,12.27,6.52,15.83,13.74,4.15,11.58,4.15,11.58-1.68,2.86-3.76,1.78-4.25,2.37-4.25,2.37S166.11,200.22,153.22,200.12Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,206.15c-8.57,4.28-12.66,2.94-12.66,2.94.57-3.34-1.35-7.37-3-10.14a33.88,33.88,0,0,0-2.3-3.31l10.45-2.81a23.5,23.5,0,0,0,1.59,3.66c2.46,4.43,4.86,3.61,5.36,3.38l.1-.05C161.68,201.4,159,206.15,159,206.15Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.34,199.87c-1.43,2-3.85,4.15-7.36,3.42-2.7-.57-5.47-2.42-7.74-4.34a33.88,33.88,0,0,0-2.3-3.31l10.45-2.81a23.5,23.5,0,0,0,1.59,3.66C155.44,200.92,157.84,200.1,158.34,199.87Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,203.44s5.72,3.6,9.84,1.49c5.42-2.77,2.21-9.35,2.21-9.35s3.95,1.35,5.85,8.45-6.45,13.44-14.3,10.31-5.68-5.05-5.68-5.05S143.46,203.44,145.48,203.44Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,203.44s5.72,3.6,9.84,1.49c5.42-2.77,2.21-9.35,2.21-9.35s3.95,1.35,5.85,8.45-6.45,13.44-14.3,10.31-5.68-5.05-5.68-5.05S143.46,203.44,145.48,203.44Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.8,168.4l-6.11,4.26a8.1,8.1,0,0,1-2.29-.74c-5.83-2.86-4.69-11.8,2.29-11.6,5.14.14,6.15,3.63,6.25,6A9.41,9.41,0,0,1,140.8,168.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.94,166.29a11.3,11.3,0,0,0-5.49.68,4.41,4.41,0,0,0-3,4.95c-5.83-2.86-4.69-11.8,2.29-11.6C139.83,160.46,140.84,164,140.94,166.29Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23,167.7c-12.81,5.74-9.91,29,7.12,28.37C157.82,195.63,162,182.85,158,174,154.68,166.71,146.69,163.92,138.23,167.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23,167.7c-12.81,5.74-9.91,29,7.12,28.37C157.82,195.63,162,182.85,158,174,154.68,166.71,146.69,163.92,138.23,167.7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.52,172.71c7.93-.57,10.79,3.49,12,11.62,1.46,10.16-.28,17.58-10.35,16.11C135.45,198.45,134.35,173.66,147.52,172.71Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.32,184.26a16.78,16.78,0,0,0,2.55,3.12,2.2,2.2,0,0,1-2,1.05Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,178.49a4.14,4.14,0,0,0-3.35,1.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.707962px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.69,177.74a3.72,3.72,0,0,1,3.21.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.707962px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.82,186.7s3.24-6.78,2.31-11.77c0,0,15.26-7.55,17.18,8.34,0,0,.52-14.27-13.14-13.61s-12.16,20.61-4.69,26C141.48,195.7,137.82,190.94,139.82,186.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.32,191a21,21,0,0,0-.93,2.83,4.57,4.57,0,0,1-.52-.05c-2.37-.22-3.4-1.1-3.82-2a2.93,2.93,0,0,1-.24-1.43,3.1,3.1,0,0,1,.14-.82,11.18,11.18,0,0,0,4.56,1.4C155,191,155.32,191,155.32,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.87,193.79c-2.37-.22-3.4-1.1-3.82-2a7.82,7.82,0,0,1,2.59.77A3,3,0,0,1,153.87,193.79Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.82,186.7s3.24-6.78,2.31-11.77c0,0,15.26-7.55,17.18,8.34,0,0,.52-14.27-13.14-13.61s-12.16,20.61-4.69,26C141.48,195.7,137.82,190.94,139.82,186.7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.23,188.28a3.48,3.48,0,0,0-4-2.91c-2.44.44-3.25,5.57,3,6.35C141.1,191.83,141.54,190.94,141.23,188.28Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,188.43s-2.25,1.32-2.34,3.34",
    style: {
      fill: "none",
      stroke: "#de5753",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87,188.52a6,6,0,0,1,.63,3.16",
    style: {
      fill: "none",
      stroke: "#de5753",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43,184.31s-.09,2-1.84,1.64",
    style: {
      fill: "none",
      stroke: "#de5753",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,183.57s.6,1.72,2,1.06",
    style: {
      fill: "none",
      stroke: "#de5753",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.42,184c.06.65-.24,1.21-.67,1.25s-.84-.45-.9-1.1.24-1.21.67-1.25S149.36,183.31,149.42,184Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.35,182.9l1.36-.68S149.12,183.47,148.35,182.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.49,183.05c.07.65-.24,1.21-.67,1.25s-.83-.45-.9-1.1.24-1.21.68-1.25S157.43,182.4,157.49,183.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.42,182l1.36-.69S157.19,182.57,156.42,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.23,176.58s5.92-1.58,9.09-.79",
    style: {
      fill: "none",
      stroke: "#de5753",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77,174.34a14,14,0,0,1,7.45,0",
    style: {
      fill: "none",
      stroke: "#de5753",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.08,234.58a64.72,64.72,0,0,0-7.49-5.8c-.64-.41-1.35-.93-2.11-1.53l3.6-4.15S154.61,228,155.08,234.58Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87,255.05l6.78,1.78s3.75-.14,3.75,2.8-2.38,12-5.41,11.24-6.89-2.69-5.94-4,3.88-5,3.88-5l-4.61-1.56Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.18,214c-5.13,5.29-10.93,33.77-4.86,38.52s26,9.6,26,9.6l1.59-7.09s-16.7-6.73-19-9.9,9.54-21,9.54-21a16.5,16.5,0,0,0-5.65-8.62C140.21,211.9,137.18,214,137.18,214Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.18,214c-5.13,5.29-10.93,33.77-4.86,38.52s26,9.6,26,9.6l1.59-7.09s-16.7-6.73-19-9.9,9.54-21,9.54-21a16.5,16.5,0,0,0-5.65-8.62C140.21,211.9,137.18,214,137.18,214Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.81494d43232226936b6a1ea116406eb7.svg";
export { ForwardRef as ReactComponent };